import React from "react"
import {
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaRedditAlien,
} from "react-icons/fa"
import * as styles from "./social-button.module.css"

const ICONS = {
  instagram: FaInstagram,
  facebook: FaFacebookF,
  twitter: FaTwitter,
  linkedin: FaLinkedinIn,
  reddit: FaRedditAlien,
}

function getSocialIcon(link) {
  const [, name] = link.match(/^https?:\/\/(.+?).com\/?.*$/)
  const Icon = ICONS[name]

  if (Icon) {
    return { name, Icon }
  }

  console.warn(`SocialButton: ${name} not supported`)
  return {}
}

export const SocialButton = ({ className = "", link }) => {
  const { name, Icon } = getSocialIcon(link)

  if (Icon) {
    return (
      <a
        className={`${className} ${styles.button} ${styles[name]}`}
        href={link}
      >
        <Icon />
      </a>
    )
  }

  return null
}
